import { updates } from '@/mocks/homeData';

export default function UpdatesSection() {
  const tagBgMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-700',
    accent: 'bg-accent-100 text-accent-700',
    secondary: 'bg-secondary-100 text-secondary-700',
  };

  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            最新吃瓜快讯
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            实时追踪全网最热娱乐八卦，第一时间推送劲爆消息
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-start gap-4 py-4 ${
                idx < updates.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className="flex flex-col items-center gap-1 min-w-[80px]">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date.split(' ')[0]}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date.split(' ')[1]}</span>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start gap-3">
                  <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${tagBgMap[item.tagColor] || tagBgMap.secondary}`}>
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base text-foreground-800 leading-relaxed cursor-pointer hover:text-primary-500 transition-colors duration-200">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}